export const WA_NUMBER = '528716090380'
